import userService from "../../../services/user.service";

async function getOfficeLocations() {
  try {
    const payload = {
      filter: {
        textSearch: "",
      },
      pageNumber: -1,
      pageSize: 10,
    }; // Modify as needed
    const response = await userService.getOfficeLocations(payload);
    if (response.data && response.data.status) {
      console.log(response.data.result);
      return JSON.stringify(response.data.result);
    } else {
      return (
        JSON.stringify(response.data.message) ||
        "Failed to fetch office locations."
      );
    }
  } catch (error) {
    const errorMessage =
      (error.response && error.response.data && error.response.data.message) ||
      error.message ||
      "An unexpected error occurred.";
    console.error("Error fetching office locations:", errorMessage);
    return JSON.stringify(errorMessage);
  }
}

async function addOfficeLocationToDatabase({
  address,
  contact1,
  cityId,
  isHeadOffice,
}) {
  try {
    const payload = {
      address,
      contact1,
      contact2: "",
      email: "",
      fax: "",
      extensions: "",
      cityId,
      isHeadOffice,
    };
    const response = await userService.addOfficeLocation(payload);
    if (response.data && response.data.status) {
      console.log(response.data.result);
      return JSON.stringify(response.data.result);
    } else {
      return (
        JSON.stringify(response.data.message) ||
        "Failed to add office location."
      );
    }
  } catch (error) {
    const errorMessage =
      (error.response && error.response.data && error.response.data.message) ||
      error.message ||
      "An unexpected error occurred.";
    console.error("Error adding office location:", errorMessage);
    return JSON.stringify(errorMessage);
  }
}

async function updateOfficeLocationInDatabase({
    address,
    contact1,
    cityId,
    isHeadOffice,
    officeLocationId
  }) {
  try {
    const payload = {
        address,
        contact1,
        contact2: "",
        email: "",
        fax: "",
        extensions: "",
        cityId,
        isHeadOffice,
        id: officeLocationId
      };
    const response = await userService.updateOfficeLocation(payload);
    if (response.data && response.data.status) {
      console.log(response.data.result);
      return JSON.stringify(response.data.result);
    } else {
      return (
        JSON.stringify(response.data.message) ||
        "Failed to update office location."
      );
    }
  } catch (error) {
    const errorMessage =
      (error.response && error.response.data && error.response.data.message) ||
      error.message ||
      "An unexpected error occurred.";
    console.error("Error updating office location:", errorMessage);
    return JSON.stringify(errorMessage);
  }
}

export default {
  getOfficeLocations,
  addOfficeLocationToDatabase,
  updateOfficeLocationInDatabase,
  officeLocationTools: [
    {
      type: "function",
      function: {
        name: "getOfficeLocations",
        description:
          "Fetch all office locations from the database. Ensure all locations are returned unless specified otherwise.",
        parameters: {
          type: "object",
          properties: {},
        },
      },
    },
    {
      type: "function",
      function: {
        name: "addOfficeLocationToDatabase",
        description: "Add a new office location to the database",
        parameters: {
          type: "object",
          properties: {
            address: {
              type: "string",
              description: "Complete address of the office location",
            },
            contact1: {
              type: "string",
              description: "Primary contact number for the office location",
            },
            cityId: {
              type: "string",
              description: "The unique ID of the city where the office is located",
            },
            isHeadOffice: {
              type: "boolean",
              description: "Indicates whether the location is the head office",
            },
          },
          required: ["address", "contact1", "cityId", "cityName", "isHeadOffice"],
        },
      },
    },
    {
      type: "function",
      function: {
        name: "updateOfficeLocationInDatabase",
        description: "Update an existing office location in the database",
        parameters: {
          type: "object",
          properties: {
            officeLocationId: {
              type: "string",
              description: "The Id of the office location that need to update"
            },
            address: {
              type: "string",
              description: "Updated address of the office location",
            },
            contact1: {
              type: "string",
              description: "Updated primary contact number for the office location",
            },
            cityId: {
              type: "string",
              description: "Updated city ID where the office is located",
            },
            isHeadOffice: {
              type: "boolean",
              description: "Indicates whether the location remains the head office",
            },
          },
          required: ["address", "contact1", "cityId", "cityName", "isHeadOffice"],
        },
      },
    } 
  ]
};
